import { EntityRequestRemote } from "../../entity/EntityRequestRemote";

export class DtoRequestRemotesPostRes extends EntityRequestRemote {}
